interface DiagramSVGProps {
  color: string;
  style: React.CSSProperties;
}

const DiagramSVG = ({ color, style }: DiagramSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="51"
    viewBox="0 0 52 51"
    fill="none"
  >
    <g clipPath="url(#clip0_465_5991)">
      <path
        d="M22.8618 13.4374L25.3988 15.6946L29.0547 11.2188"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M34.9295 3.33741C29.2285 4.01265 25.6787 0.73291 25.6787 0.73291C25.6787 0.73291 22.1385 4.01265 16.4279 3.33741C16.4279 3.33741 14.6433 18.4435 25.6787 21.704C36.7044 18.4435 34.9295 3.33741 34.9295 3.33741Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.7812 41.6816V45.6366"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M30.0286 34.6011H49.5334C50.2472 34.6011 50.8163 35.1799 50.8163 35.884V40.3889C50.8163 41.1027 50.2376 41.6718 49.5334 41.6718H30.0286C29.3147 41.6718 28.7456 41.093 28.7456 40.3889V35.884C28.7456 35.1702 29.3244 34.6011 30.0286 34.6011Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.7808 38.1411H45.9255"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.4528 38.1414C48.4528 38.0064 48.337 37.8906 48.202 37.8906C48.0669 37.8906 47.9512 38.0064 47.9512 38.1414C47.9512 38.2765 48.0669 38.3922 48.202 38.3922C48.337 38.3922 48.4528 38.2765 48.4528 38.1414Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M49.5338 23.2568H30.0193C29.3107 23.2568 28.7363 23.8312 28.7363 24.5398V29.0543C28.7363 29.7628 29.3107 30.3372 30.0193 30.3372H49.5338C50.2423 30.3372 50.8167 29.7628 50.8167 29.0543V24.5398C50.8167 23.8312 50.2423 23.2568 49.5338 23.2568Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.7812 26.7969H45.9259"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.4533 26.7972C48.4533 26.6621 48.3375 26.5464 48.2025 26.5464C48.0674 26.5464 47.9517 26.6621 47.9517 26.7972C47.9517 26.9322 48.0674 27.048 48.2025 27.048C48.3375 27.048 48.4533 26.9322 48.4533 26.7972Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.4531 11.9033H49.5335C50.2473 11.9033 50.8164 12.4821 50.8164 13.1863V17.6911C50.8164 18.4049 50.2376 18.9741 49.5335 18.9741H33.2119"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.7812 15.4434H45.9259"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.4533 15.4437C48.4533 15.3086 48.3375 15.1929 48.2025 15.1929C48.0674 15.1929 47.9517 15.3086 47.9517 15.4437C47.9517 15.5787 48.0674 15.6945 48.2025 15.6945C48.3375 15.6945 48.4533 15.5787 48.4533 15.4437Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.5752 41.6816V45.6366"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.9872 45.6362H9.16406V50.4594H13.9872V45.6362Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M42.1928 45.6362H37.3696V50.4594H42.1928V45.6362Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M1.823 34.6011H21.3278C22.0416 34.6011 22.6108 35.1799 22.6108 35.884V40.3889C22.6108 41.1027 22.032 41.6718 21.3278 41.6718H1.823C1.10917 41.6718 0.540039 41.093 0.540039 40.3889V35.884C0.540039 35.1702 1.11882 34.6011 1.823 34.6011Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.5752 38.1411H17.7199"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.257 38.1414C20.257 38.0064 20.1412 37.8906 20.0062 37.8906C19.8711 37.8906 19.7554 38.0064 19.7554 38.1414C19.7554 38.2765 19.8711 38.3922 20.0062 38.3922C20.1412 38.3922 20.257 38.2765 20.257 38.1414Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M21.3375 23.2568H1.823C1.11444 23.2568 0.540039 23.8312 0.540039 24.5398V29.0543C0.540039 29.7628 1.11444 30.3372 1.823 30.3372H21.3375C22.046 30.3372 22.6204 29.7628 22.6204 29.0543V24.5398C22.6204 23.8312 22.046 23.2568 21.3375 23.2568Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.5752 26.7969H17.7199"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.257 26.7972C20.257 26.6621 20.1412 26.5464 20.0062 26.5464C19.8711 26.5464 19.7554 26.6621 19.7554 26.7972C19.7554 26.9322 19.8711 27.048 20.0062 27.048C20.1412 27.048 20.257 26.9322 20.257 26.7972Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.1445 18.9838H1.823C1.10917 18.9838 0.540039 18.405 0.540039 17.7009V13.196C0.540039 12.4822 1.11882 11.9131 1.823 11.9131H14.6526"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.5752 15.4438H16.08"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.7812 34.6009V30.3276"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.7812 23.2572V18.9839"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.5752 34.6009V30.3276"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.5752 23.2572V18.9839"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M0.540039 48.0483H9.16383"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.9873 48.0483H37.3699"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M42.1929 48.0483H50.8167"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_465_5991">
        <rect width="51.3569" height="51" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default DiagramSVG;
